import React from 'react'
import { Trans } from 'react-i18next'
import { Checkbox, Link } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  leftTop: {
    paddingLeft: 0,
  },
}))

export type ConfirmationProps = {
  checked: boolean
  onCheckboxClick: (event: React.ChangeEvent<HTMLInputElement>) => void
  termsUrl: string
  privacyPolicyUrl: string
  serviceUseUrl?: string
  leftTop?: boolean
}

const Confirmation: React.FC<ConfirmationProps> = ({
  checked,
  onCheckboxClick,
  termsUrl,
  privacyPolicyUrl,
  serviceUseUrl,
  leftTop,
}: ConfirmationProps) => {
  const { classes } = useStyles()
  return (
    <label className={classes.root}>
      <Checkbox
        checked={checked}
        className={leftTop ? classes.leftTop : ''}
        onChange={onCheckboxClick}
        color="primary"
      />
      <span>
        {serviceUseUrl ? (
          <Trans
            i18nKey="trans.利用規約、プライバシーポリシー、YaDocサービス仕様適合開示書に同意する"
            components={{
              terms: (
                <Link
                  key={termsUrl}
                  href={termsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
              privacy: (
                <Link
                  key={privacyPolicyUrl}
                  href={privacyPolicyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
              service: (
                <Link
                  key={serviceUseUrl}
                  href={serviceUseUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
            }}
          />
        ) : (
          <Trans
            i18nKey="trans.利用規約とプライバシーポリシーに同意する"
            components={{
              terms: (
                <Link
                  key={termsUrl}
                  href={termsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
              privacy: (
                <Link
                  key={privacyPolicyUrl}
                  href={privacyPolicyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
            }}
          />
        )}
      </span>
    </label>
  )
}

export default Confirmation
